import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";

// @material-ui/icons
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
// core components
import Card from "components/Card/Card.js";

import LanguageSelector from "container/componentsCustom/LanguageSelectorContainer.js";

import logo_emma_dark from "../../assets/img/logo_dark.png";
import logo_emma_light from "../../assets/img/logo_light.png";

// import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.js";
import {
  warningColor,
  hexToRgb
} from "assets/jss/material-dashboard-pro-react.js";

const useStyles = makeStyles(styles);

function checkColor(color) {
  var c = color.substring(1); // strip #
  var rgb = parseInt(c, 16); // convert rrggbb to decimal
  var r = (rgb >> 16) & 0xff; // extract red
  var g = (rgb >> 8) & 0xff; // extract green
  var b = (rgb >> 0) & 0xff; // extract blue
  var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

  if (luma < 80) {
    return true; // ritorna chiaro
  } else {
    return false; // ritorna scuro
  }
}

export default function CartNavBar(props) {
  // const [cartCounter, setCartCounter] = useState(0);

  const [openNotification, setOpenNotification] = React.useState(null);
  const handleClickNotification = event => {
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null);
    } else {
      setOpenNotification(event.currentTarget);
    }
  };

  const classes = useStyles();
  const {
    rtlActive,
    // cart,
    currency,
    // restaurant,
    customStyle,
    // shippingInfo,
    cartParams
  } = props;

  const wrapper = classNames({
    [classes.wrapperRTL]: rtlActive
  });
  const managerClasses = classNames({
    [classes.managerClasses]: true
  });

  const {
    // totalPrice,
    // servicesFees,
    // deliveryCost,
    // total,
    cartCounter,
    totToShow
  } = cartParams;
  var logo_emma = logo_emma_dark;
  if (
    (!window.location.pathname.includes("/contacts") &&
      !window.location.pathname.includes("/information") &&
      !window.location.pathname.includes("/payment") &&
      !window.location.pathname.includes("/thank-you")) ||
    (!window.location.pathname.includes("/contacts") &&
      !window.location.pathname.includes("/information") &&
      !window.location.pathname.includes("/payment") &&
      !window.location.pathname.includes("/thank-you") &&
      checkColor(customStyle.museoColor)) // true == scuro??
  ) {
    logo_emma = logo_emma_light;
  }

  return (
    <div className={wrapper}>
      <div className={managerClasses}>
        <div style={{ marginRight: "10px" }}>
          {!window.location.pathname.includes("contacts") &&
            !window.location.pathname.includes("information") &&
            !window.location.pathname.includes("payment") &&
            !window.location.pathname.includes("thank-you") && (
              <Card className={classes.card} style={{ marginTop: "10px" }}>
                {/* <Link to={`/${id}/cart`} className={classes.linkCart}> */}
                <div
                  className={classes.linkCart}
                  style={{ cursor: "pointer" }}
                  onClick={props?.onCartPress ? props?.onCartPress : () => {}}
                >
                  <span
                    style={{
                      paddingLeft: "10px",
                      paddingRight: "10px"
                    }}
                    className={classes.cartName}
                  >
                    <span style={{ paddingRight: "2px" }}>
                      {currency && currency.symbol ? currency.symbol : ""}
                    </span>
                    {totToShow.toFixed(2)}
                  </span>
                  <div className={classes.containerNavCart}>
                    {cartCounter && cartCounter > 0 ? (
                      // <span className={'notifications'}>{cartCounter}</span>
                      <span className={classes.notifications}>
                        {cartCounter}
                      </span>
                    ) : null}

                    <ShoppingBasketIcon
                      className={
                        classes.headerLinksSvg +
                        " " +
                        (rtlActive
                          ? classes.links + " " + classes.linksRTL
                          : classes.links)
                      }
                      style={{
                        color:
                          "rgba(" +
                          hexToRgb(customStyle.buttonCart || warningColor[0]) +
                          ", 0.7)"
                      }}
                    />
                  </div>
                </div>
                {/* </Link> */}
              </Card>
            )}
        </div>
        <div style={{ marginRight: "10px" }}>
          <LanguageSelector
            classContainer="language-selector-header"
            color="#4a4a4a"
          />
        </div>
        <div
          style={{ marginRight: "10px", padding: "10px 0 0 0" }}
          className="logo_emma_navbar"
        >
          <img style={{ maxHeight: "40px" }} src={logo_emma} alt="logo" />
        </div>
        {/* <div style={{ marginRight: "10px" }}>
          <DateSelector />
        </div>*/}
        {/* <CurrencySelector /> */}
        <Hidden mdUp implementation="css">
          <span onClick={handleClickNotification} className={classes.linkText}>
            {rtlActive ? "إعلام" : "Notification"}
          </span>
        </Hidden>
      </div>
    </div>
  );
}

CartNavBar.propTypes = {
  rtlActive: PropTypes.bool,
  cart: PropTypes.arrayOf(PropTypes.object).isRequired,
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string
  }).isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number
  }).isRequired,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string
  }).isRequired,
  // restaurant: PropTypes.object.isRequired,
  customStyle: PropTypes.object
  // cart: PropTypes.arrayOf(PropTypes.any).isRequired
};

CartNavBar.defaultProps = {
  customStyle: {}
};
